import React from 'react';
import PaintTitle from './PaintTitle.js';
import { motion } from 'framer-motion';

const skillsData = {
    "Software & Infrastructure": ["Python", "JavaScript", "React / Next.js", "Node.js", "C / C++ / C#", "Git", "AWS / DynamoDB", "Linux", "HTML / CSS"],
    "Hardware & Robotics": ["Raspberry Pi", "ESP8266", "PIC32", "Arduino", "PID Control", "Verilog", "Fusion 360", "3D Printing"],
    "Data & Quantitative": ["MATLAB", "Kalman Filters", "Cointegration", "Backtesting", "Transaction Cost Modeling", "Pandas", "NumPy"]
};

const AnimatedBorder = () => (
    <svg className="border-svg" width="100%" height="100%" preserveAspectRatio="none">
        <rect width="100%" height="100%" />
    </svg>
);


function Skills() {
    return (
        <section className="skills-container" id="skills">
            <PaintTitle className="skills-title">Technical skills</PaintTitle>
            <div className="skills-grid">
                {Object.entries(skillsData).map(([category, skillsList], index) => (
                    <motion.div
                        className="skill-category"
                        key={category}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.5 }}
                        transition={{ duration: 0.5, delay: index * 0.2 }}
                    >
                        <AnimatedBorder />
                        <h3>{category}</h3>
                        <ul>
                            {skillsList.map(skill => <li key={skill}>{skill}</li>)}
                        </ul>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}

export default Skills;
